import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { Api } from '../../../../../../../shared/constants/api';
import { ViewManualAuditIssueComponent } from './view/view-manual-audit-issue.component';
import { RouteWrapperComponent } from '../../../../../components/route-wrapper/route-wrapper.component';
import { ManualAuditIssuesComponent } from './manual-audit-issues.component';

const routes: Routes = [
  {
    path: '',
    component: ManualAuditIssuesComponent,
    data: {
      title: ['view_manual_evaluation_results'],
      breadcrumbs: {
        isLinkToPageAvailable: true,
        queryParamsHandling: 'merge',
      },
    },
  },
  {
    path: `:${Api.manualAuditIssueId}`,
    component: RouteWrapperComponent,
    children: [
      {
        path: `${Api.view}`,
        component: ViewManualAuditIssueComponent,
        data: {
          title: ['findings_details'],
          breadcrumbs: {
            isLinkToPageAvailable: true,
            queryParamsHandling: 'merge',
          },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManualAuditIssuesRoutingModule {}
